<template>
  <div>
    <!--列表-->
    <el-container class="list-wrapper">
      <el-main class="table-wrap">
        <div style="margin-top: 5px; float:left;font-weight: bold; font-size: 14px">调整记录</div>
        <div style="margin-bottom: 10px; float: right">
          <el-button class="orange-btn" size="mini" @click="onekeyRead"
            >一键已读
          </el-button>
        </div>
        <div class="tabText">
          <span 
            v-for="(item,index) in ['未读消息','已读消息']" 
            :key="index" 
            :class="colorIndex == index ? 'textColor' : ''"
            @click="tabTextClick(index)"
            >{{item}}</span>
        </div>
        <el-table
          stripe
          border
          ref="table"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          highlight-current-row
          :data="tableData.records"
          :height="tableHeight"
          v-if="tableHeight"
          v-loading="loading"
        >
          <el-table-column label="商品编码" prop="goodsCode" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column label="商品名称" prop="goodsName" show-overflow-tooltip width="250"></el-table-column>
          <el-table-column label="调整店铺" prop="applyStoreName" show-overflow-tooltip></el-table-column>
          <el-table-column label="调整人" prop="applyPerson" show-overflow-tooltip></el-table-column>
          <el-table-column label="调整时间" prop="creationDate" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="调整量" prop="adjustNumber" show-overflow-tooltip></el-table-column>
          <el-table-column label="接收店铺" prop="acceptStoreName" show-overflow-tooltip></el-table-column>
          <el-table-column label="接收人" prop="acceptPerson"  show-overflow-tooltip></el-table-column>
          <el-table-column label="接收时间" prop="updatedDate" width="200" show-overflow-tooltip></el-table-column>
        </el-table>
      </el-main>
      <el-footer height="auto" style="text-align: right; padding-bottom: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
import moment from "moment";
export default {
  name: "newProductSales",
  model: { 
    prop: 'searchForm',
    event: 'input'
  },
  props: ['searchForm','storeList'],
  data() {
    return {
      header_H: "38px",
      loading: false,
      exportLoading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchFormData: [],
      rules: {},
      columnData: [],
      loading: false,
      activeTable: 0,
      colorIndex: 0,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {
    tableHeight() {
      return window.innerHeight - 301;
    },
    windowWidth() {
      return document.body.clientWidth;
    },
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1
      this.init()
    },
    init() {
      this.loading = true
      let data = {
        readFlag: this.colorIndex == 1 ? 'Y' : 'N',
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        ...this.searchForm
      }
      this.$q.clearanceManagement.modifyLogSearch({data: data}).then(res => {
        this.tableData = res.data
      }).finally(()=>{
        this.loading = false
      })
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      this.colorIndex = 0
      let searchForm = {
        storeCode: this.storeList[0].storeCode,
      };
      this.$emit('input',searchForm)
      this.tableData.pageNum = 1
      this.$nextTick(_=>{
        this.onSearch()
      })
    },
    
    tabTextClick(index) {
      this.colorIndex = index
      this.onSearch()
    },

    //一键已读
    onekeyRead() {
      this.$q.clearanceManagement.modifyLogOneKeyRead().then(res => {
        this.$message.success('一键已读成功')
        this.onSearch()
        this.$emit('messageStatus')
      })
    },

     // 导出
    exportExcel() {
      console.log(this.searchFormData)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData
        },
        reportName: this.reportName
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
          loading.close()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.onSearch()
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form--inline .el-form-item:last-child {
  margin-right: 0;
}

.list-wrapper {
  background-color: #ffffff;
  border-radius: 6px;
}

.header-redio {
  margin: 10px;
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

.table-wrap {
  padding: 10px;
  border-radius: 6px;
}

.tabText {
  clear: both
  margin-bottom: 10px
  font-size: 14px
    span {
      margin-right: 30px
      cursor: pointer
    }
}
.textColor {
  color: #03A9F4
}

>>> .el-link.el-link--primary {
  margin-right: 5px;
}
</style>
